import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const ChartDownIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M21.0002 10.6698C20.735 10.6698 20.4807 10.8103 20.2932 11.0602C20.1057 11.3102 20.0004 11.6492 20.0004 12.0027V15.4549L13.7117 7.05775C13.6188 6.93282 13.5082 6.83366 13.3863 6.76599C13.2645 6.69832 13.1338 6.66348 13.0018 6.66348C12.8699 6.66348 12.7392 6.69832 12.6173 6.76599C12.4955 6.83366 12.3849 6.93282 12.292 7.05775L9.00266 11.4562L3.71374 4.39199C3.52548 4.141 3.27013 4 3.00389 4C2.73764 4 2.4823 4.141 2.29403 4.39199C2.10577 4.64297 2 4.98338 2 5.33833C2 5.69328 2.10577 6.03369 2.29403 6.28468L8.2928 14.282C8.38575 14.4069 8.49633 14.506 8.61816 14.5737C8.74 14.6414 8.87067 14.6762 9.00266 14.6762C9.13464 14.6762 9.26532 14.6414 9.38716 14.5737C9.50899 14.506 9.61957 14.4069 9.71251 14.282L13.0018 9.88345L18.5907 17.3342H16.0012C15.7361 17.3342 15.4818 17.4747 15.2943 17.7246C15.1068 17.9746 15.0014 18.3136 15.0014 18.6671C15.0014 19.0206 15.1068 19.3596 15.2943 19.6096C15.4818 19.8596 15.7361 20 16.0012 20H21.0002C21.1309 19.9979 21.2599 19.9617 21.3801 19.8934C21.6244 19.7581 21.8186 19.4993 21.92 19.1736C21.9712 19.0134 21.9984 18.8413 22 18.6671V12.0027C22 11.6492 21.8947 11.3102 21.7072 11.0602C21.5197 10.8103 21.2654 10.6698 21.0002 10.6698Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
